// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1yY5q","emails":"CreateEditClinics_emails__2zvMi","emailTagLabel":"CreateEditClinics_emailTagLabel__1iOYl"};